import { render, staticRenderFns } from "./unAuthorizedView.vue?vue&type=template&id=bb1948c2"
import script from "./unAuthorizedView.vue?vue&type=script&lang=js"
export * from "./unAuthorizedView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports